export default "__VITE_ASSET__DWuJyeN5__"